/**
 * global WhoElse
 */


jQuery().ready( function() {
	//$("#spreuken").slides({ generatePagination: false, randomize: false, play: 3000, effect: 'fade' });
	jQuery( ".quotes" ).addClass( 'active' );
	jQuery( '.uitklap .content' ).hide();
	jQuery( '.uitklap h3' ).addClass( 'clickable' ).click( function() {
		jQuery( this ).next( '.content' ).toggle();
	} );

	WhoElse.Spreuken = new Cycle( jQuery( '.quotes .content' ) )
	WhoElse.Quotes = new Cycle( jQuery( '#spreuken' ) )
	WhoElse.Menu = new Menu( jQuery( '#hamburger' ),jQuery( '#menu-close' ), jQuery( '#sitenav-container' ) )


} );

class Menu {
	constructor( open, close, menu ) {
		this.$open = open;
		this.$close = close;
		this.$menu = menu;
		this.init();
	}

	init(){
		let self = this;
		this.$open.on( 'click', function(){
			self.enable();
		});

		this.$close.on( 'click', function(){
			self.disable();
		});
	}

	enable(){
		this.$menu.addClass('active');
	}

	disable(){
		this.$menu.removeClass('active');
	}

	toggle(){
		if( this.$menu.hasClass('active' ) ){
			this.disable();
		} else {
			this.enable();
		}
	}

}

class Cycle {
	constructor( el ) {
		this.timeout = 2000;
		this.$el = el;
		this.$current = el.children().first();
		this.interval = null;

		this.init();
	}

	init() {
		this.shuffle();
		this.$el.children().hide();
		this.$current.show();

		this.startWait();

	}

	startWait() {
		let self = this;
		setTimeout( () => {
			self.slide().done( () => {
				self.startWait();
			} );
		}, 2000 );
	}

	getNextElement() {
		let el = this.$current.next();
		if ( el.length === 0 ) {
			el = this.$el.children().first();
		}

		return el;
	}

	slide() {
		let deferred = jQuery.Deferred();
		let $current = this.$current;
		let $next = this.getNextElement();

		$current.fadeOut( 1500, () => {
			$next.fadeIn( 1500, () => {
				this.$current = $next;
				deferred.resolve();
			} )
		} );

		return deferred;
	}

	shuffle() {
		let $parent = this.$el;
		let $children = this.$el.children();
		while ( $children.length ) {
			$parent.append( $children.splice( Math.floor( Math.random() * $children.length ), 1 )[ 0 ] );
		}
	}
}